import './Button.scss';

import { Button as AntdButton } from 'antd';
import type { ButtonProps } from 'antd/lib/button';
import React from 'react';

interface Props extends ButtonProps {
  showShadow?: boolean;
  className?: string;
}

const Button = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  return (
    <AntdButton
      {...props}
      ref={ref}
      className={`Button ${props.className ? props.className : ''} ${
        props.showShadow ? 'show-shadow' : ''
      }`}
    />
  );
});

Button.displayName = 'Button';

export default Button;
